import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  callCreateOrder,
  callDeleteOrder,
  callDownloadImages,
  callGetOrderDetail,
  callGetOrders,
  callUpdateOrder
} from 'helpers/api_helper';
import { getAllImagesFromObjects, replaceImagesJson } from 'helpers/utils';

const toTotal = (response: any) => Number(response?.headers?.['x-total-count'] || 0);

export const createOrder = createAsyncThunk(
  'orders/callCreateOrder',
  async (param: any, { rejectWithValue }) => {
    try {
      const response = await callCreateOrder(param);
      return response;
    } catch (error) {
      return rejectWithValue('Unexpected error');
    }
  },
);

export const updateOrder = createAsyncThunk(
  'orders/callUpdateOrder',
  async (payload: any, { rejectWithValue }) => {
    try {
      const { id, ...param } = payload;
      const response = await callUpdateOrder(id, param);
      return response;
    } catch (error) {
      return rejectWithValue('Unexpected error');
    }
  },
);

export const deleteOrder = createAsyncThunk(
  'orders/callDeleteOrder',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await callDeleteOrder(id);
      return response;
    } catch (error) {
      return rejectWithValue('Unexpected error');
    }
  },
);

export const getOrders = createAsyncThunk(
  'orders/callGetOrders',
  async (param: any, { rejectWithValue }) => {
    try {
      const response: any = await callGetOrders(param);
      return {
        data: response?.data,
        total: toTotal(response),
      };
    } catch (error) {
      return rejectWithValue('Unexpected error');
    }
  },
);

export const getOrderWithPresign = createAsyncThunk(
  'orders/getOrderWithPresign',
  async (param: any, { rejectWithValue }) => {
    try {
      const response: any = await callGetOrders(param);
      const orders: any[] = Array.isArray(response?.data) ? response.data : [];
      let data = orders;

      if (orders.length) {
        const images = getAllImagesFromObjects(orders);

        if (!images.length) {
          return {
            data,
            total: toTotal(response),
          };
        }
        const s3Images: any = await callDownloadImages({ storagePaths: images });

        if (s3Images.length) {
          const urls = s3Images.map((item: any) => item.url);
          data = replaceImagesJson(orders, urls);
        }
      }

      return {
        data,
        total: toTotal(response),
      };
    } catch (error) {
      return rejectWithValue('Unexpected error');
    }
  },
);

export const getOrderDetailWithPresign = createAsyncThunk(
  'orders/getOrderDetailWithPresign',
  async (id: number, { rejectWithValue }) => {
    try {
      const order: any = await callGetOrderDetail(id);
      const images = getAllImagesFromObjects([order]);

      if (!images.length) {
        return order;
      }

      const s3Images: any = await callDownloadImages({ storagePaths: images });

      if (!s3Images.length) {
        return order;
      }

      return replaceImagesJson([order], s3Images.map((item: any) => item.url))[0];
    } catch (error) {
      return rejectWithValue('Unexpected error');
    }
  },
);
